import ResourceUpdateBuilder from './resourceUpdateBuilder';
import { EHRResource } from '@getvim/vim-os-api';
import { EHR } from '@getvim/vim-os-sdk-api';
import { convertTargetProviderToWritebackTargetProvider } from './utils';

type updatableOrder = EHR.UpdatableOrderParams;
type updatableOrderTargetProvider = NonNullable<updatableOrder['targetProvider']>;

export default class OrderUpdateBuilder extends ResourceUpdateBuilder<typeof EHRResource.orders> {
  protected readonly ehrResource = EHRResource.orders;

  public appendNotes(notes: NonNullable<updatableOrder['basicInformation']>['notes']) {
    return this.appendField('basicInformation', { notes });
  }

  public setOrderTargetProvider(targetProvider: updatableOrderTargetProvider) {
    const writebackTargetProvider = convertTargetProviderToWritebackTargetProvider(targetProvider);
    return this.setObjectField('targetProvider', writebackTargetProvider);
  }
}
